import React, {Component} from "react";
import {connect} from "react-redux";
import TrackingNr from "../../components/TrackingNr";
import Loading from "../../components/Loading";
import {fromJS} from "immutable";
import gql from "graphql-tag";
import {graphql} from "react-apollo";
import {ON_QUOTE_UPDATED} from "../../queries/shipping";
import "../../components/Table.scss";

class ShippingQuote extends Component {

  componentDidMount() {
    if (this.props.orderId && !this.unsubscribe) {
      this.subscribe(this.props.orderId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.orderId && (prevProps.orderId !== this.props.orderId)) {
      this.subscribe(this.props.orderId);
    }
  }

  subscribe(orderId) {
    if (this.unsubscribe) this.unsubscribe();
    this.unsubscribe = this.props.subscribeToUpdates(this.props, {});
  }

  render() {
    let {loading, error, shippingQuote} = this.props.data;
    if (loading) return <Loading />
    // if (error) return <GraphQLErrors error={error} />
    if (error) return <p>Not found</p>
    let data = fromJS(shippingQuote);

    return (
      <div className="ShippingQuote Table">
        <table>
          <thead>
            <tr>
              <td>Status</td>
              <td>Courier</td>
              <td>Shipment Id</td>
              <td>Service</td>
              <td>weight</td>
              <td>Charge</td>
              <td>Negotiated Rate</td>
            </tr>
          </thead>
          <tbody>
            <tr className="item">
              <td>{data.get("status")}</td>
              <td>{data.get("courierId")}</td>
              <td className="u-selectable"><TrackingNr trackingNr={data.getIn(["quote", "shipmentId"])} courierId={data.get("courierId")} /></td>
              <td>{data.getIn(["quote", "service"], "n/a")}</td>
              <td>{data.getIn(["quote", "weight"], "n/a")}</td>
              <td>{data.getIn(["quote", "shipmentCharge"], "n/a")}</td>
              <td>{data.getIn(["quote", "negotiatedRates"], "n/a")}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

}

const COURIER_QUOTE = gql`
  query shippingQuote($orderId:ID!) {
    shippingQuote(orderId:$orderId) {
      orderId
      courierId
      status
      quote {
        shipmentId
        shipmentCharge
        negotiatedRates
        weight
        service
      }
    }
  }
`;


const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_QUOTE_UPDATED,
      variables: {
        orderId: props.orderId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withQuery = graphql(COURIER_QUOTE, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      orderId: props.orderId
    }
  })
});

const withSubscription = connect(null, mapDispatchToProps);

export default withQuery(withSubscription(ShippingQuote));